<template>
    <div class="routeItem">
        <div class="routeLeft">
            <span></span><span class="route_num">{{parseInt(arrIndex)+parseInt('2')}}</span>
        </div>
        <div class="routeRight">
            <div class="route_box" v-if="arrIndex%2==0 ||arrIndex==0">
                <span>{{route_content.name}}</span>
                <div class="route_img_right route_img">
                    <img src="../../assets/images/service/route_bg.png" alt="" class="img_border">
                    <img :src="weburl + route_content.content" alt="" class="img_content"></div>
            </div>
            <div class="route_box" v-else>
                <div class="route_img_left route_img">
                    <img src="../../assets/images/service/route_bg.png" alt="" class="img_border">
                    <img :src="weburl + route_content.content" alt="" class="img_content">
                </div>
                <span>{{route_content.name}}</span>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: "routeItem",
        props: ['route_content', 'arr-index'],
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang='less'>
    @import '../../assets/less/common.less';

    @color: #fa5a04;
    .routeItem {
        .routeLeft, .routeRight {
            float: left;
        }
        .routeLeft {
            width: 16%;
            margin-right: 2%;
        }
        .routeRight {
            width: 82%;
        }
        height: 110px;
        .routeLeft {
            height: 110px;
            line-height: 110px;
            text-align: center;
            display: flex;
            justify-content: center;
            position: relative;
            span {
                display: inline-block;
                width: 3px;
                height: @width;
                background: @color;
                &.route_num {
                    background: url(../../assets/images/service/route_icons.png) no-repeat;
                    position: absolute;
                    top: 39px;
                    font-size: @font;
                    color: @font-primary;
                    width: 32px;
                    height: 32px;
                    line-height: 28px;
                    text-align: center;
                    background-size: 32px auto;
                }
            }
        }
        .routeRight {
            .route_box {
                height: 110px;
                line-height: 110px;
                span {
                    display: inline-block;
                    text-align: center;
                    width: 49%;
                    font-size: @font;
                    @media (min-width: 768px){
                        font-size: @font + .4 ;
                    }

                }
                .route_img_left {
                    float: left;
                    &:extend(.img_content);
                }
                .route_img_right {
                    float: right;
                    &:extend(.img_content);
                }
                .img_content {
                    height: 100px;
                    position: absolute;
                    top: 4px;
                    left: 4px;
                    z-index: 98;
                    .border-radius(50%);
                }
                .route_img {
                    height: 110px;
                    width: 40%;
                    margin: 0 5%;
                    position: relative;
                    .img_border {
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 99;
                        width: 110px;
                    }
                }
            }

        }

    }

</style>
